<template>
  <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1H15.614" stroke="#656E8F" stroke-width="2" stroke-linecap="round" />
    <path d="M1 7.125H15.614" stroke="#656E8F" stroke-width="2" stroke-linecap="round" />
    <path d="M1 13.25H15.614" stroke="#656E8F" stroke-width="2" stroke-linecap="round" />
  </svg>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class TipIcon extends Vue {
  @Prop({ type: Boolean }) status: boolean;
}
</script>
